import React, { useState } from "react";
import '../../styles/admin.css';

const Pagination = ({ totalPages, currentPage, setPage, totaldata, pageRowdata }) => {
  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  return (
    <div className="paginationmain">
      <div className="pagination-text">
        Showing 1 to {pageRowdata} of {totaldata} entries
      </div>
      <div className="pagination">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setPage((p) => Math.max(1, p - 1));
          }}
        >
          Previous
        </a>

        {pages.map((num) => (
          <a
            href="#"
            key={num}
            className={num === currentPage ? "active" : ""}
            onClick={(e) => {
              e.preventDefault();
              setPage(num);
            }}
          >
            {num}
          </a>
        ))}

        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setPage((p) => Math.min(totalPages, p + 1));
          }}
        >
          Next
        </a>
      </div>
    </div>
  );
};

export default Pagination;
